import { Box, BoxProps, ClearIcon, Input, ValidationMessage } from '@modusign/design-system';
import { ChangeEventHandler, FocusEventHandler, MouseEventHandler } from 'react';

interface DocumentIDInputProps extends BoxProps<'div'> {
  value: string | null;
  errorMessage: string | null;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onBlur: FocusEventHandler<HTMLInputElement>;
  onClearClick: MouseEventHandler<HTMLButtonElement>;
}

export default function DocumentIDInput({
  value,
  errorMessage,
  onClearClick,
  onChange,
  onBlur,
  ...box
}: DocumentIDInputProps) {
  return (
    <Box {...box}>
      <Box sx={{ position: 'relative' }}>
        <Input
          height={48}
          isInvalid={!!errorMessage}
          placeholder="영문과 숫자, - 만 입력"
          sx={{
            padding: 4,
            fontSize: 15,
          }}
          value={value ?? ''}
          weight="regular"
          onBlur={onBlur}
          onChange={onChange}
        />
        {value && (
          <Box
            as="button"
            sx={{
              position: 'absolute',
              right: 3,
              top: 4,
            }}
            onClick={onClearClick}
          >
            <ClearIcon />
          </Box>
        )}
      </Box>
      {errorMessage && <ValidationMessage>{errorMessage}</ValidationMessage>}
    </Box>
  );
}
